import { applyBetSlipQuery, QueryBuilder } from "./Helpers";
export const BetslipConnection = {
    calculateBets(q) {
        return applyBetSlipQuery(QueryBuilder.calculateBets(q));
    },
    /**
     * Currently not implemented in Online.Sbtech.BetsCompositeBFF, however endoint and Request type are added
     */
    calculateYourBetBets(q) {
        return applyBetSlipQuery(QueryBuilder.calculateYourbetBets(q));
    },
    placeBets(q) {
        return applyBetSlipQuery(QueryBuilder.placeBets(q));
    },
    updatePurchases(q) {
        return applyBetSlipQuery(QueryBuilder.updatePurchases(q));
    },
    getPurchases() {
        return applyBetSlipQuery(QueryBuilder.getPurchases());
    }
};
//# sourceMappingURL=BetslipConnection.js.map